import { useEffect } from "react";
import { deleteStencil, archiveStencil } from "../../../lib/services/stencilService";
import { useStencils } from "../../../lib/hooks/useStencils";
import { useStencilWeeks } from "../../../lib/hooks/useStencilWeeks";

/* Centered modal with backdrop */
const ConfirmStencil = ({
  stencil,
  onClose,
  onDelete,
  setProduct1,
  setProduct2,
  archiving,
  setSelectedStencil,
  setShownSelection,
  showArchived
}) => {
  const { stencils, setStencils } = useStencils();
  const { stencilWeeks, setStencilWeeks } = useStencilWeeks();

  // Close with ESC key
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const submit = async () => {
    if (archiving) {
      let archived = stencil.archived ? 0 : 1;

          // Call to archive stencil:
    const res = await archiveStencil(stencil.id, archived);
    if (res && res.ok) {
      const newStencil = {
        ...stencil,
        archived : archived,
      };
      let newStencils = [];

      // Update stencil in stencil list:
      for (var s in stencils) {
        if (stencils[s].id === newStencil.id)
          newStencils.push(newStencil);
        else
          newStencils.push(stencils[s]);
      }

      // Remove instances of the removed stencil from local stencil_week store
      if (archived) {
        const filteredSW = stencilWeeks.filter(
          (sw) => sw.stencil_id !== stencil.id
        );
        setStencilWeeks([...filteredSW]);
      }

      setSelectedStencil(newStencil);
      setStencils(newStencils);
      setShownSelection(newStencils.filter((s) => showArchived ? true : s.archived === 0));
    } else {
      alert("Error archiving stencil.");
    }
    } else {
      // Call to delete stencil
      const res = await deleteStencil(stencil.id);
      if (res.ok) {
        const newStencils = stencils.filter((s) => s.id !== stencil.id);

        // Remove instances of the removed stencil from local stencil_week store
        const filteredSW = stencilWeeks.filter(
          (sw) => sw.stencil_id !== stencil.id
        );
        setStencilWeeks([...filteredSW]);

        // Replace stencils with newStencils having the deleted stencil removed
        setStencils(newStencils);
        setProduct1(newStencils);
        setProduct2(newStencils);

        onDelete();
      } else {
        alert("Error deleting stencil.");
      }
    }
    onClose();
  };

  return (
    <div className="confirm-overlay" role="presentation" onClick={onClose}>
      {/* stop propagation so clicks inside the card don't close */}
      <div
        className="confirm-card"
        role="dialog"
        aria-modal="true"
        style={{
          width: "auto",
          backgroundColor: "rgb(237, 71, 9)",
          outline: "none",
          border: "none",
          color: "white",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {(!!archiving && (
          <p className="confirm-text">
            {stencil.archived
              ? `Are you sure you want to unarchive this stencil?`
              : `Are you sure you want to archive this stencil?`}
          </p>
        )) || (
          <p className="confirm-text">
            {`Are you sure you want to delete this stencil?`}
          </p>
        )}
        <div style={{ textAlign: "center" }}>
          <p>{stencil.id}</p>
          <p>{stencil.name}</p>
          <img
            key={stencil.image_name}
            src={`/api/stencils/files/${stencil.image_name}`}
            alt={stencil.name}
            width={100}
          />
        </div>
        <br />

        <div className="confirm-actions">
          <button
            className="btn confirm-no"
            style={{
              outline: "none",
              border: "none",
              color: "white",
              backgroundColor: "darkgreen",
            }}
            onClick={onClose}
          >
            No
          </button>
          <button
            className="btn confirm-yes"
            style={{
              outline: "none",
              border: "none",
              color: "white",
              backgroundColor: "darkgreen",
            }}
            onClick={submit}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmStencil;
